import { AppThunk } from '../../../../storage/store';
import { fetchStart, fetchSuccess, fetchFailed } from './slice';
import { fetchChargerStatusAPI } from './api';
import { ChargerStatusFilters } from '../../model/reports';
import { getToken } from '../../../../utils/auth';

export const getChargerStatus = (filters: ChargerStatusFilters = {}): AppThunk => async (dispatch) => {
  dispatch(fetchStart());
  try {
    const token = getToken() || '';
    const data = await fetchChargerStatusAPI(token, filters);
    dispatch(fetchSuccess(data));
  } catch (err: any) {
    dispatch(fetchFailed(err?.message || 'Failed to load charger status.'));
  }
};
